import { request } from '@/request/request';

export default {
  // 题库分类树
  categoryTree(params) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/question_category/categoryTree`,
      method: 'get',
      params,
    });
  },
  // 题库分类扁平列表
  categoryListAll(params) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/question_category/categoryList`,
      method: 'get',
      params,
    });
  },
  // 新增分类
  categoryAdd(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/question_category/categoryAdd`,
      method: 'post',
      data,
    });
  },
  // 更新分类
  categoryUpdate(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/question_category/categoryUpdate`,
      method: 'post',
      data,
    });
  },
  // 删除分类
  categoryDelete(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/question_category/categoryDelete`,
      method: 'post',
      data,
    });
  },
};
